import { FlexibleWidthXYPlot, XAxis, AreaSeries, Borders } from "react-vis";

export function Chart(props: any) {
  const data = props.data;
  const total = props.total;
  const title = props.title;
  const description = props.description;

  return (
    <div className="pointers">
      <h6>{title}</h6>
      <small>{description}</small>
      <h5 className="chart-total">{total}</h5>

      <FlexibleWidthXYPlot height={170} className="main-chart">
        <XAxis
          title="X Axis"
          style={{
            line: { stroke: "#ADDDE1" },
            ticks: { stroke: "#ADDDE1" },
            text: { stroke: "none", fill: "#6b6b76", fontWeight: 600 },
          }}
        />

        <AreaSeries data={data} />
      
      </FlexibleWidthXYPlot>
    </div>
  );
}

export default Chart;
